import { useState, useEffect } from 'react';
import { format, parseISO } from 'date-fns'
// @mui
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers-pro';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import { CrewAvatar } from '../profile';
import Iconify from '../../components/Iconify';


export default function TodoEditDialog({ isOpen, todo, closeDialog, edit, openDelete, isSubmitting}) {
  const { user } = useAuth();
  const [todoContent, setTodoContent] = useState('');
  const [todoContentError, setTodoContentError] = useState(false);
  const [targetDate, setTargetDate] = useState(null);

  const handleTodoContent = (e) => {
    setTodoContentError(!!!e.target.value);
    setTodoContent(e.target.value);
  }

  const handleTargetDate = (newValue) => {
    setTargetDate(newValue);
  }

  const close = async () => {
    setTodoContent('');
    setTargetDate(null);
    setTodoContentError(false);
    closeDialog();
  }

  const editTodo = async () => {
    if (!todoContent) {
      setTodoContentError(true);
      return;
    }
    try {
      if (targetDate) {
        const formattedTargetDate = format(targetDate, 'yyyy-MM-dd');
        await edit(todoContent, formattedTargetDate);
      } else {
        await edit(todoContent, null);
      }
      close();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (isOpen) {
      setTodoContent(todo?.content);
      if (todo?.target_date) {
        setTargetDate(parseISO(todo?.target_date));
      }
    } else {
      setTodoContent('');
      setTargetDate(null);
      setTodoContentError(false);
    }
  }, [isOpen]);

  function DialogTitleWithCloseButton(props) {
    const { children, onClose } = props;

    return (
      <DialogTitle sx={{ mb: 3 }}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Iconify icon={'eva:close-fill'} />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogTitleWithCloseButton onClose={close}>
        투두를 수정할까요?
      </DialogTitleWithCloseButton>
      <DialogContent sx={{ pb: 0 }}>
        <Stack spacing={1} sx={{ width: 1 }}>
          <Typography variant="subtitle2">
            업무를 한 줄로 적어주세요
          </Typography>
          <TextField
            fullWidth
            multiline
            value={todoContent}
            error={todoContentError}
            helperText={todoContentError ? '내용을 입력해주세요' : ''}
            onChange={handleTodoContent}
          />
        </Stack>
        <Box sx={{ width: 1, textAlign: "end" }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {todoContent?.length === 0 ? "500자 이내" : `${todoContent?.length}/500`}
          </Typography>
        </Box>

        <Stack spacing={1} sx={{ width: 1, mt: 3 }}>
          <Typography variant="subtitle2">
            완료해야 할 날짜를 설정해주세요 (선택)
          </Typography>
          <DatePicker
            inputFormat="yyyy-MM-dd"
            disablePast
            mask={"____-__-__"}
            value={targetDate}
            onChange={handleTargetDate}
            renderInput={(params) => (
              <TextField {...params} fullWidth />
            )}
          />
        </Stack>

        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2, mb: {xs: 0, sm: 3} }}>
          <CrewAvatar hashId={user?.crew?.randomhash} nickname={user?.crew?.nickname} nameVariant={"body2"} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          color="error"
          sx={{ px: 5 }}
          loading={isSubmitting}
          onClick={openDelete}
        >
          삭제
        </LoadingButton>
        <LoadingButton
          size="large"
          sx={{ px: 5 }}
          loading={isSubmitting}
          variant="contained"
          onClick={editTodo}
          disabled={todoContent?.length > 255}
        >
          수정하기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}